import { LoadingCircleAnimation } from '~/assets';
import { SceneWrapper } from '~/components';
import { observer } from '~/modules';
import {
  Description,
  LoadingContainer,
  LoadingIndicator,
  Title,
} from './styles';

const OnboardingConfirmation: React.FC = () => {
  return (
    <SceneWrapper>
      <LoadingContainer>
        <LoadingIndicator options={{ animationData: LoadingCircleAnimation }} />
        <Title>Documentos em análise</Title>
        <Description>
          Aguarde enquanto concluímos a análise dos seus documentos
        </Description>
      </LoadingContainer>
    </SceneWrapper>
  );
};

export default observer(OnboardingConfirmation);
